export const validateFileSize = (file: Blob | File, maxSize: number) => {
  const fileSizeKB = file.size / 1024;

  if (fileSizeKB > maxSize) {
    return false;
  }

  return true;
};

export const getMaxSizeTitle = (maxSize?: number) => {
  if (!maxSize) return undefined;

  if (maxSize < 1024) {
    return `Max Size: ${maxSize}KB`;
  }

  return `Max Size: ${maxSize / 1024}MB`;
};
